module.exports = function(gantt){
	gantt.$inject = function(module){
		return module(this.$services);
	};
};


//////////////////
// WEBPACK FOOTER
// ./sources/core/common/import.js
// module id = 22
// module chunks = 0